import SkeletonTable from "@/components/SkeletonTable"
import { getListPerguruanTinggiProdi } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

export default function MasterPerguruanTinggiProdiPage() {
  const [searchParams] = useSearchParams()
  const pageParams = searchParams.get("page")
  const rowsPerPageParams = searchParams.get("rowsPerPage")
  const searchQueryParams = searchParams.get("search")

  const { data, isPending } = useQuery({
    queryKey: [
      "listPerguruanTinggiProdi",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
    ],
    queryFn: () =>
      getListPerguruanTinggiProdi(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string
      ),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} paginationData={data} columns={columns} />
    </div>
  )
}
